import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  ClubSeasonUserRank,
  ClubSeasonsRanksResponse,
  GetClubSeasonRanksRequest
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';

import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import type { BoundRequest } from '@swf/core/types/Request';
import { ENDPOINTS } from '@swf/poker';
import type { HomeGamesWidgetModel } from '@swf/poker';

import { PKR_USERS_IN_LEADER_BOARD_NUMBER } from '../../constants/constants';

interface Props {
  clubId: string;
  limit?: number;
  seasonId?: number;
}

const sendRequest = async ({
  clubId,
  playMoney,
  request,
  limit,
  seasonId
}: {
  clubId: number;
  playMoney: boolean;
  request: BoundRequest;
  limit: number;
  seasonId: number;
}) => {
  const { body } = await request<ClubSeasonsRanksResponse>({
    service: ENDPOINTS.clubSeasonsRanks,
    body: {
      getSeasonRanks: {
        clubId: Number(clubId),
        playMoney,
        seasonId,
        limit
      }
    } as GetClubSeasonRanksRequest,
    http: true,
    method: 'GET'
  });

  return body;
};

export const fetchClubSeasonRanks = async (
  { clubId, limit = 0, seasonId = 0 }: Props,
  { request, dispatch, widget: { uid } }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];

  const hasPoints = (ranks: ClubSeasonUserRank[]) =>
    ranks.some((rank) => rank.pointsTotal && rank.pointsTotal > 0);

  try {
    const realMoneyResponseBody = await sendRequest({
      clubId: Number(clubId),
      playMoney: false,
      limit,
      request,
      seasonId
    });

    const realMoneyRanks = realMoneyResponseBody.seasonRanksReply?.ranks || [];

    if (realMoneyRanks?.length < PKR_USERS_IN_LEADER_BOARD_NUMBER || !hasPoints(realMoneyRanks)) {
      const playMoneyResponseBody = await sendRequest({
        clubId: Number(clubId),
        playMoney: true,
        request,
        limit,
        seasonId
      });

      const playMoneyRanks = playMoneyResponseBody.seasonRanksReply?.ranks || [];

      if (hasPoints(playMoneyRanks)) {
        widgetDispatch.setClubSeasonRanks(playMoneyRanks);
      }
    } else {
      widgetDispatch.setClubSeasonRanks(realMoneyRanks);
    }
  } catch (error) {
    // TODO: Set error and display error msg if this request fails
  }
};
